import { NgIf, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { ModalHeaderComponent } from '@cf/shared/dialog';
import { ButtonComponent } from '@cf/shared/ui/button';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  templateUrl: './popover-modal.component.html',
  /* styles: [
        `
          cf-popover-modal cf-card-table a[ec-card-table-row] {
            padding: 0 15px;
          }
        `,
      ],*/
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [ModalHeaderComponent, NgTemplateOutlet, NgIf, ButtonComponent, NgxTolgeeModule],
})
export class PopoverModalComponent {
  @Input() windowTitle!: string;

  @Input() submitButton!: string;

  currentTemplate!: TemplateRef<any>;
}
